import React from "react";
import PageTransition from "@/components/mobile/PageTransition";
import RebuildNavigationMap from "@/components/navigation-rebuild/RebuildNavigationMap";
import NavigationRoutePlannerSeo from "@/components/navigation-rebuild/NavigationRoutePlannerSeo";

export default function NavigationPage() {
  return (
    <PageTransition>
      <RebuildNavigationMap />
      <NavigationRoutePlannerSeo />
    </PageTransition>
  );
}